module.exports = __webpack_public_path__ + "static/media/291310-P7M4UY-325-01 1.d99a2956.png";